import ReportDefinitionItem from "@/pages/Models/ReportDefinitionItem";
import ReturnInspectionAdditionalExpenseRecord from "@/models/server/AdditionalExpenseRecords/ReturnInspectionAdditionalExpenseRecord";

export default class UpdateReturnInspectionStepRequest {
    public deviceExternalId: string = "";

    public item: ReportDefinitionItem | null = null;

    public additionalExpenseRecords: ReturnInspectionAdditionalExpenseRecord[] | null = null;
}